import { Col, Row } from "reactstrap";
import PriceBasicInput from "./PriceBasicInput";
import NumberFormatter from "../../commons/NumberFormatter";
import { calculatePrice } from "./PriceCalculator";
import CustomTooltip from "../Tooltip/CustomTooltip";

const PriceInputComponent = (props) => {
  const { valueArray, onChangeArray, disabledArray, afa, mennyiseg, tizedesjegy, tooltipText } = props;

  // true-t ad vissza, ha olyan az input, amikor nem kell újraszámolni a többi értéket (pl "5.", "-", mert ezek átmeneti bemenetek pl "5.2" és "-5"-höz)
  const isNoCalcInput = (value) => {
    value += '';
    return value.slice(-1) === '.';
  }

  const calculateNettoEgysegInput = (value, onChange) => {
    if (isNoCalcInput(value)) {
      return onChange([value, valueArray[1], valueArray[2], valueArray[3], valueArray[4], valueArray[5]])
    }
    return onChange(calculatePrice(value, afa, mennyiseg, tizedesjegy));
  };

  return (
    <>
      <Row className="mb-1">
        <Col md="3">
          {tooltipText && <CustomTooltip text={tooltipText} id="priceInputTT" />}
        </Col>
        <Col md="3">Nettó:</Col>
        <Col md="3">ÁFA:</Col>
        <Col md="3">Bruttó:</Col>
      </Row>
      <Row className="align-items-center mb-1">
        <Col md="3">Egységár</Col>
        <Col md="3">
          <PriceBasicInput
            value={valueArray[0]}
            maxTizedesjegy={6}
            onChange={(v) => calculateNettoEgysegInput(v, onChangeArray)}
            disabled={disabledArray[0]}
          />
        </Col>
        <Col md="3">
          <PriceBasicInput
            maxTizedesjegy={6}
            value={valueArray[1]}
            disabled
          />
        </Col>
        <Col md="3">
          <PriceBasicInput
            value={valueArray[2]}
            maxTizedesjegy={6}
            disabled
          />
        </Col>
        <Col md="3">Tétel érték</Col>
        <Col md="3">
          <PriceBasicInput
            maxTizedesjegy={tizedesjegy}
            value={valueArray[3]}
            disabled
          />
        </Col>
        <Col md="3">
          <PriceBasicInput
            maxTizedesjegy={tizedesjegy}
            value={valueArray[4]}
            disabled
          />
        </Col>
        <Col md="3">
          <PriceBasicInput
            maxTizedesjegy={tizedesjegy}
            value={valueArray[5]}
            disabled
          />
        </Col>
      </Row>
    </>
  );
};

export default PriceInputComponent;
